import { useState } from 'react';

import { ChoiceList } from '@/modules/signup-flow/components/layout/ChoiceList';
import { buttonClass } from '@/modules/signup-flow/components/layout/motion';
import {
  Field,
  StepActions,
} from '@/modules/signup-flow/components/layout/SignupLayoutParts';
import { StepHeader } from '@/modules/signup-flow/components/layout/StepHeader';
import {
  SIGN_UP_FLOW_STEPS,
  signupFlowStep,
} from '@/modules/signup-flow/signupFlowSteps';
import { Button } from '@/modules/ui/components/button/Button';

export interface HiringGoals {
  companyStage: string;
  numberOfHires: string;
}

const stages = [
  { value: 'Pre-seed', label: 'Pre-seed' },
  { value: 'Seed', label: 'Seed' },
  { value: 'Series A', label: 'Series A' },
  { value: 'Growth', label: 'Growth' },
];

const hires = [
  { value: 'not-hiring', label: 'Not hiring right now' },
  { value: '1-3', label: '1 to 3 hires' },
  { value: '3-10', label: '3 to 10 hires' },
  { value: '10+', label: 'More than 10 hires' },
];

interface HiringGoalsFormProps {
  initial: HiringGoals;
  isSubmitting?: boolean;
  onBack: () => void;
  onContinue: (goals: HiringGoals) => void;
}

/** Step 2, presentational; `CompanyGoals.tsx` wires persistence. */
export const HiringGoalsForm = ({
  initial,
  isSubmitting = false,
  onBack,
  onContinue,
}: HiringGoalsFormProps) => {
  const [goals, setGoals] = useState(initial);

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    onContinue(goals);
  };

  return (
    <form className="flex flex-col gap-8" onSubmit={submit}>
      <StepHeader
        step={signupFlowStep.companyGoals}
        totalSteps={SIGN_UP_FLOW_STEPS}
        title="What are your hiring goals?"
        subtitle="This shapes how Finlay paces sourcing for you."
      />

      <div className="flex flex-col gap-6">
        <Field label="Company stage">
          <ChoiceList
            name="Company stage"
            value={goals.companyStage}
            options={stages}
            onChange={(companyStage) => setGoals({ ...goals, companyStage })}
            stagger
          />
        </Field>
        <Field label="Hires planned this quarter">
          <ChoiceList
            name="Hires planned this quarter"
            value={goals.numberOfHires}
            options={hires}
            onChange={(numberOfHires) => setGoals({ ...goals, numberOfHires })}
            stagger
          />
        </Field>
      </div>

      <StepActions>
        <Button
          variant="ghost"
          className={buttonClass}
          disabled={isSubmitting}
          onClick={onBack}
        >
          Back
        </Button>
        <Button type="submit" className={buttonClass} loading={isSubmitting}>
          Continue
        </Button>
      </StepActions>
    </form>
  );
};
